import { links } from '../components/submission/common';
import { CookieStore } from '../services/cookieStore';

const { REACT_APP_SITE_URL, REACT_APP_SITE_URL_DEV } = process.env;

export const addUvidParam = (url: string): string => {
  const uvid = CookieStore.getUvid();
  if (!uvid) return url;

  const urlObj = new URL(url); // eslint-disable-line
  urlObj.searchParams.append('uvid', uvid);
  return urlObj.toString();
};

export const redirectTo = (url: string) => {
  window.location.replace(addUvidParam(url));
};

export const directToItemTypePage = () => {
  window.location.href = links.submissionFlowRepositioning;
};

export const directToHomePage = () => redirectTo(REACT_APP_SITE_URL_DEV || REACT_APP_SITE_URL || '');

export const redirectToNewItem = (itemId: string) => {
  const newItemUrl = `${process.env.REACT_APP_SELLER_DASHBOARD_URL}/shipping?itemId=${itemId}&survey=true` || '';
  redirectTo(newItemUrl);
};

export const redirectToMyItems = (itemId: string) => {
  const myItemsUrl = `${process.env.REACT_APP_SELLER_DASHBOARD_URL}/my-items?itemId=${itemId}&survey=true` || '';
  redirectTo(myItemsUrl);
};
